import {
  Calendar,
  Circle,
  ClipboardList,
  MapPin,
  Package,
  Receipt,
  Sheet,
  ShoppingCart
} from "lucide-react"

/**
 * Itens do menu principal da sidebar
 */
export const MENU_ITEMS = [
  {
    icon: Sheet,
    label: "Relatórios",
    id: "relatorios",
    description: "Relatórios do sistema",
    children: [],
  },
  {
    icon: Package,
    label: "Cliente",
    id: "cliente",
    href: "/clientes",
    description: "Gerenciar clientes",
    permission: "Cliente",
    action: "islist",
  },
  {
    icon: ShoppingCart,
    label: "Serviços",
    id: "servicos",
    href: "/servicos",
    description: "Gerenciar serviços",
    permission: "Serviço",
    action: "islist",
  },
  {
    icon: MapPin,
    label: "Painel",
    id: "painel",
    href: "/paineis",
    description: "Painel de controle",
    permission: "Painel",
    action: "islist",
  },
  {
    icon: Circle,
    label: "Circuito",
    id: "circuito",
    href: "/circuitos",
    description: "Gerenciar circuitos",
    permission: "Circuito",
    action: "islist",
  },
  {
    icon: Calendar,
    label: "Orçamento",
    id: "orcamento",
    href: "/orcamento",
    hasIndicator: true,
    description: "Verificar orçamento",
  },
  {
    icon: Receipt,
    label: "Venda",
    id: "venda",
    href: "/vendas",
    hasIndicator: true,
    description: "Gerenciar vendas",
    permission: "Vendas",
    action: "islist",
  },
  {
    icon: ClipboardList,
    label: "Auditoria de Vendas",
    id: "auditoria-vendas",
    href: "/auditoria/reabertura-vendas",
    hasIndicator: true,
    description: "Auditoria de reabertura de vendas",
    permission: "Vendas",
    action: "islist",
  },
]
